import { useContext } from 'react';
import { useStoreWithEqualityFn, UseBoundStoreWithEqualityFn } from 'zustand/traditional';
import { Store } from './createStore';
import { StoreContext } from './StoreContext';

export const useStore = ((selector, equalityFn) => {
  const store = useContext(StoreContext);
  if (!store) throw new Error('Missing Store.Provider in the tree');
  return useStoreWithEqualityFn(store, selector, equalityFn);
}) as UseBoundStoreWithEqualityFn<Store>;
